export default __webpack_public_path__ + "static/media/bnr4.baf611b7.jpg";